<template>
    <div class="aup-box-select w-100">
        <div class="row m-0">
            <div class="col-12 col-md-6" v-for="(item, index) in items" :key="'last-half' + index">
                <BaseButton
					:filled="local_value.indexOf(item.toLowerCase()) > -1 ? true : false"
					:color="local_value.indexOf(item.toLowerCase()) > -1 ? 'orange' : 'black'"
					border="thin"
					class="w-100"
					@click.native="toggleItem(item.toLowerCase(), $event)"
                >
                error:call:3
                </BaseButton>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseBoxSelect",
    props: {
        items: {
            type: Array,
        },
        value: {
            type: Array,
        }
    },
    watch: {
        value(val) {
            this.local_value = Array.isArray(val) ? [...val] : [];
        }
    },
    computed: {
        isSelected: () => {

        },
    },
    data() {
        return {
            local_value: Array.isArray(this.value) ? [...this.value] : []
        };
    },
    methods: {
        toggleItem(item, event) {
            if (this.local_value.indexOf(item) > -1) {
                this.local_value = this.local_value.filter(arrayItem => arrayItem !== item);
            } else {
                this.local_value = [...this.local_value, item];
            }
            this.$emit('input', [...this.local_value]);
            this.$nextTick(() => {
                if (event && event.currentTarget) {
                    event.currentTarget.blur();
                }
            });
        }
    }
};
</script>
<style lang="scss">
    @import "../../assets/scss/all";
    .aup-box-select {
        .aup-base-button {
            margin-bottom: 12px;

            &.empty-black:focus {
                background: transparent;
                color: $sony-black;
                border-color: $sony-black;
                box-shadow: none;
            }
        }
    }
</style>
